module.exports = __webpack_public_path__ + "img/link-5.b48e9018.png";